import { createReducer, on } from '@ngrx/store';
import {
  setSearchMatch,
  setSearchPhrase,
} from './public-session-state.actions';

export const publisSessionStateFeatureKey = 'publisSessionState';

export interface State {
  searchPhrase: string;
  searchMatch: Array<string>;
}

export const initialState: State = {
  searchMatch: null,
  searchPhrase: '',
};
export const publicSessionReducer = createReducer(
  initialState,
  on(setSearchPhrase, (state, args) => {
    return {
      ...state,
      searchPhrase: args.searchPhrase,
    };
  }),
  on(setSearchMatch, (state, args) => {
    return {
      ...state,
      searchMatch: args.match,
    };
  })
);
